<template>
  <div class="all-wrap">
    <div class="tabs">
      <div class="tab-item-active myAsk"
           @click="changeTab('getWordSub')">购买历史</div>
    </div>
    <div class="bought-list"
         v-if="dataList&&dataList.length">
      <!-- 标题 -->
      <div class="bought-title">
        <ul>
          <li>商品</li>
          <li>类型</li>
          <li>价格</li>
          <li>购买时间</li>
          <li>快递单号</li>
          <li>剩余过期时间</li>
        </ul>
      </div>
      <!-- 列表 -->
      <div class="bought-content">
        <ul>
          <li v-for="data in dataList"
              :key="data.id"
              @click="toDetail(data)">
            <div class="bought-img" >
              <img :src="data.url?data.url:imgUrl" />
              <p class="goodsname">{{data.goodsName}}</p>
            </div>
            <div>{{data.itemCategoriesChar}}</div>
            <div>￥{{data.tradedPrice || '0'}}</div>
            <div>{{data.createTime}}</div>
            <div>{{data.logisticsNumber}}</div>
            <div v-if="data.itemCategories == '6'">&nbsp;</div>
            <div v-else-if="data.loseTime >= 0">剩余{{data.loseTime}}天</div>
            <div v-else-if="data.loseTime < 0"
                 style="color:red"> 已过期{{data.loseTime * -1}}天</div>
          </li>
        </ul>
      </div>
    </div>
    <div v-else>
      <div style="text-align:center">
        <img src="@/assets/img/good/noGood.png"
             alt="暂无数据">
      </div>
    </div>
    <el-pagination background
                   style="margin-top:10px;text-align: center;"
                   layout="prev, pager, next, total, jumper, slot"
                   prev-text="上一页"
                   next-text="下一页"
                   @size-change="handleSizeChange"
                   @current-change="getDataList"
                   :current-page="currentPage"
                   :page-size="10"
                   :pager-count="5"
                   :total="total">
    </el-pagination>
  </div>
</template>
<script>
export default {
  data () {
    return {
      pageIndex: 1,
      pageSize: 10,
      total: 0,
      dataList: [],
      imgUrl: require('@/assets/img/占位图.png'),
      // imgUrl: '../../../../../static/img/占位图.png',
      currentPage: 1,
      lastOmit: '',
      nextOmit: '...',
      pageList: [1, 2, 3, 4, 5],
      jumpTargetPage: 1
    }
  },
  mounted () {
    this.getDataList()
  },
  methods: {
    // 跳转到详情
    toDetail (val) {
      if (val.itemCategories === '6') {
        // 专题预告
        this.$router.push({
          path: '/liveNotice'
        })
      } else {
        this.$router.push({
          path: '/courseDetail',
          query: {
            id: val.goodsId
          }
        })
      }
    },
    handleSizeChange (val) {
      this.getDataList(1)
    },
    getDataList (page = this.currentPage) {
      this.currentPage = page
      this.$http.post(`/front/train/trainUserBuy/userCenterBuyHistory`,
        {
          'page': this.currentPage,
          'limit': 10,
          'id': this.$store.state.user.userId
        })
        .then(data => {
          this.dataList = data.data.data.data
          // 分页
          this.total = data.data.data.count
          this.changePageTo(this.currentPage)
        })
      this.jumpTargetPage = 1
    },
    jumpLastPage () {
      if (this.currentPage > 1) {
        var newCurrent = this.currentPage - 1
        this.getDataList(newCurrent)
      } else {
        this.$message.info('这已经是第一页啦')
      }
    },
    jumpNextPage () {
      if (this.currentPage < this.totalPage) {
        var newCurrent = this.currentPage + 1
        this.getDataList(newCurrent)
      } else {
        this.$message.info('这已经是最后一页啦')
      }
    },
    changePageTo (page) {
      // window.scrollTo(0, 0);
      if (this.totalPage > 5) {
        if (page > 2 && page < this.totalPage - 1) {
          var newPageList = []
          for (let index = page - 2; index < page + 3; index++) {
            newPageList.push(index)
          }
          this.pageList = newPageList
          this.currentPage = page
          this.lastOmit = '...'
          this.nextOmit = '...'
        } else if (page <= 2) {
          this.pageList = [1, 2, 3, 4, 5]
          this.currentPage = page
          this.lastOmit = ''
          if (page >= this.totalPage - 2) {
            this.nextOmit = ''
          } else {
            this.nextOmit = '...'
          }
        } else {
          var newPageList2 = [
            this.totalPage - 4,
            this.totalPage - 3,
            this.totalPage - 2,
            this.totalPage - 1,
            this.totalPage
          ]
          this.pageList = newPageList2
          this.currentPage = page
          this.lastOmit = '...'
          this.nextOmit = ''
        }
      } else {
        var newPageList5 = []
        for (let index = 1; index <= this.totalPage; index++) {
          newPageList5.push(index)
        }
        this.pageList = newPageList5
        this.lastOmit = ''
        this.nextOmit = ''
        this.currentPage = page
      }
      // this.getDataList()
    },
    jumpFarPage () {
      if (this.jumpTargetPage >= 1 && this.jumpTargetPage <= this.totalPage) {
        if (this.totalPage > 5) {
          if (
            this.jumpTargetPage > 2 && this.jumpTargetPage < this.totalPage - 4
          ) {
            var newPageList3 = []
            for (
              let index = this.jumpTargetPage - 2;
              index < this.jumpTargetPage + 3;
              index++
            ) {
              newPageList3.push(index)
            }
            this.pageList = newPageList3
            this.currentPage = this.jumpTargetPage
            this.lastOmit = '...'
            this.nextOmit = '...'
          } else if (this.jumpTargetPage <= 2) {
            this.pageList = [1, 2, 3, 4, 5]
            this.currentPage = this.jumpTargetPage
            this.lastOmit = ''
            if (this.jumpTargetPage > this.totalPage - 3) {
              this.nextOmit = ''
            } else {
              this.nextOmit = '...'
            }
          } else {
            var newPageList4 = [
              this.totalPage - 4,
              this.totalPage - 3,
              this.totalPage - 2,
              this.totalPage - 1,
              this.totalPage
            ]
            this.pageList = newPageList4
            this.currentPage = this.jumpTargetPage
            this.lastOmit = '...'
            this.nextOmit = ''
          }
        } else {
          var newPageList5 = []
          for (let index = 1; index <= this.totalPage; index++) {
            newPageList5.push(index)
          }
          this.pageList = newPageList5
          this.lastOmit = ''
          this.nextOmit = ''
          this.currentPage = this.jumpTargetPage
        }
        this.getDataList()
        window.scrollTo(0, 0)
      } else {
        this.$message.error('请输入正确的页码')
      }
    },
    // 每页数
    sizeChangeHandle (val) {
      this.pageSize = val
      this.pageIndex = 1
      this.getDataList()
    },
    // 当前页
    currentChangeHandle (val) {
      this.pageIndex = val
      this.getDataList()
    },
    // 多选
    selectionChangeHandle (val) {
      this.dataListSelections = val
    }
  }
}
</script>
<style scoped>
.myAsk {
  width: 80px;
  text-align: center;
}
.bought-list {
  margin: 0 69px;
  margin-bottom: 10px;
}
.bought-title {
  width: 100%;
  height: 40px;
  line-height: 40px;
  text-align: center;
  background: #f8f8f8;
  color: #696969;
}
.bought-title ul {
  width: 100%;
  height: 40px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.bought-title ul li {
  width: 130px;
}
.bought-content {
  width: 100%;
  height: auto;
}
.bought-content ul {
  width: 100%;
  height: auto;
}
.bought-content ul li {
  width: 100%;
  height: 165px;
  background: #fff;
  padding: 10px 0px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  border-bottom: 1px solid #ccc;
  color: #333;
  cursor: pointer;
}
.bought-content ul li div {
  width: 130px;
  text-align: center;
  line-height: 150px;
}
.bought-content .bought-img {
  width: 130px;
  line-height: 20px;
}
.bought-img img {
  width: 120px;
  height: 120px;
}
.goodsname {
  width: 130px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
